import React, { ReactNode } from 'react';
import { Breadcrumbs as PdcBreadcrumbs } from '@mzc-pdc/ui';

export const Breadcrumbs = (props: { isLoading?: boolean; children: ReactNode }) => (
  <PdcBreadcrumbs {...props}>{props.children}</PdcBreadcrumbs>
);
